import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "data"],
  _excluded2 = ["data", "error"];
import { DataFetchingClient, DataFetchingClientProvider, useQuery as useQueryBase, useMutation as useMutationBase, registerQuery as registerQueryBase } from 'data-fetching-client';
export const unwrapHubHttpError = error => {
  if (error && error.networkError) {
    return error.networkError;
  }
  return undefined;
};
const unwrapData = data => {
  if (!data) return null;
  const key = Object.keys(data)[0];
  return data[key];
};
export * from 'data-fetching-client';
export class AcademyFetchingClient extends DataFetchingClient {
  queryUnwrapped(opts) {
    return this.query(opts).then(result => {
      const key = opts.query.definitions[0].name.value;
      const data = result.data;
      return data[key];
    }, error => {
      throw unwrapHubHttpError(error);
    });
  }
}
export const useQuery = (query, options) => {
  const _useQueryBase = useQueryBase(query, options),
    {
      error,
      data
    } = _useQueryBase,
    rest = _objectWithoutPropertiesLoose(_useQueryBase, _excluded);
  return Object.assign({}, rest, {
    data: unwrapData(data),
    error: unwrapHubHttpError(error)
  });
};
export const useMutation = (query, options) => {
  const [mutate, _ref] = useMutationBase(query, options);
  const {
      data,
      error
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  return [mutate, Object.assign({}, rest, {
    data: unwrapData(data),
    error: unwrapHubHttpError(error)
  })];
};
export const registerQuery = options => {
  return registerQueryBase({
    fieldName: options.fieldName,
    args: options.args,
    fetcher(variables, ctx) {
      return options.fetcher(variables, ctx);
    }
  });
};
export { DataFetchingClientProvider };